<template>
	<v-dialog v-model="dialog" @click:outside="$emit('onClose')" max-width="590">
      <v-card>
        <v-card-title class="headline pl-4">
           Veuillez sélectionner un droit utilisateur existant
        </v-card-title>

        <v-card-text>
          <v-combobox
            v-model="selectedUserRight"
            :items="userRights"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="@id"
            label="Liste des droits utilisateurs"
            placeholder="Commencer à taper un droit utilisateur pour rechercher ... "
            prepend-icon="mdi-database-search"
            return-object
          ></v-combobox>
        </v-card-text>

        <v-divider></v-divider>

        <v-expand-transition>
          <div v-if="selectedUserRight !== null">
            <p class="pl-4">
              Nom du droit utilisateur  : {{ selectedUserRight.name }}</p>
          </div>
        </v-expand-transition>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="pink darken-1" text @click="$emit('onClose')">Annuler</v-btn>
          
          <!-- clone du userRight + modifier droit utilissateur selectionné dans le modal -->
          <v-btn color="blue darken-1" text @click="$emit('submit', selectedUserRight)"> Valider </v-btn>
           

          <router-link :to="{ name: 'creerDroitUtilisateur' }">
            <v-btn color="grey darken-1" text dialog="false">Passer cette étape</v-btn>
          </router-link>
        </v-card-actions>

      </v-card>
    </v-dialog>
</template>

<script>

export default {
  data: () => ({
    isLoading: false,
    selectedUserRight: null,
    search: null,
  }),
  props: {
    dialog: Boolean,
    userRights: Array,
  },
};
</script>
